export default __webpack_public_path__ + "static/media/Spin torre RD_Interactive LightMix0002.60466368.webp";